const fullscreenIconSpritesheet = {
  "name": "fullscreenIconSpritesheet",
  "tileHeight": 64,
  "tileWidth": 64,
  "spacing": 0,
  "tileCount": 1,
  "columns": 1,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/fullscreenIconSpritesheet.png",
  "sprites": {
    "fullscreenTouchIcon": [0]
  }
}
export default fullscreenIconSpritesheet;
